"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

var _Error = _interopRequireDefault(require("../Icons/Error"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin-right: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tcolor: ", ";\n\tfont-size: 16px;\n\tmargin: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Message = _styledComponents.default.p(_templateObject(), _colors.default.error);

Message.displayName = 'Message';
var MarginIcon = (0, _styledComponents.default)(_Error.default)(_templateObject2(), _spacing.default.s2);
MarginIcon.displayName = 'ErrorIcon';

var ErrorMessage = function ErrorMessage(_ref) {
  var showIcon = _ref.showIcon,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["showIcon", "children"]);

  return _react.default.createElement(Message, props, showIcon && _react.default.createElement(MarginIcon, {
    size: 16,
    color: _colors.default.error
  }), children);
};

ErrorMessage.displayName = 'ErrorMessage';
ErrorMessage.propTypes = {
  children: _propTypes.node.isRequired,
  showIcon: _propTypes.bool
};
ErrorMessage.defaultProps = {
  showIcon: true
};
var _default = ErrorMessage;
exports.default = _default;